import { createFileRoute } from '@tanstack/react-router';

import { queryClient } from '~app/query-client';

import { getAllEventsWithSearchOptions } from '~entities/events/api/get-all-events-with-search';

import { EventListPage } from '~features/events/ui/event-list-page';

export const Route = createFileRoute('/_auth/_layout/events/')({
  component: EventListPage,
  loader: async ({ preload }) => {
    // Preload initial event data with default parameters
    const params = {
      page: 1,
      limit: 10,
      name: '',
      isStudio: true,
    };

    // Use the same queryOptions that the component will use
    const options = getAllEventsWithSearchOptions(params);

    // Preload the data using the queryClient
    await queryClient.ensureQueryData(options);

    return {
      maxAge: preload ? 5 * 60 * 1000 : 0, // Preloaded data stays valid for 5 minutes
    };
  },
});
